// Shared dropdown option lists for the User Profile size fields (ProfileEdit).
// Each <Select> renders a leading blank option (value "", label "Not specified")
// on top of these.

export const SHIRT_SIZES = ["XS", "S", "M", "L", "XL", "2XL", "3XL"];

// Letter-size pants scale — the list behind the "letter" pants category below.
export const PANTS_SIZES = ["XS", "S", "M", "L", "XL", "2XL", "3XL"];

// Pants size categories. `value` is the code stored in
// name_profiles.pants_size_category (CHECK-constrained to these three);
// `label` is the edit-form option text, `shortLabel` the read-only display text.
export const PANTS_CATEGORIES = [
  { value: "men", label: "Men's", shortLabel: "Men's" },
  { value: "women", label: "Women's", shortLabel: "Women's" },
  { value: "letter", label: "Letter Sizes (S/M/L) / Elastic Waist", shortLabel: "Letter/Elastic" },
];

// Men's waist 28 through 48 inches in 1-inch steps ("28", "29", ... "48").
export const MENS_WAIST_SIZES = Array.from({ length: 21 }, (_, i) => String(28 + i));

// Men's inseam 26 through 38 inches in 1-inch steps ("26", "27", ... "38").
export const MENS_INSEAM_SIZES = Array.from({ length: 13 }, (_, i) => String(26 + i));

// Women's even sizes "00", "0", "2", ... "24".
export const WOMENS_PANTS_SIZES = ["00", ...Array.from({ length: 13 }, (_, i) => String(i * 2))];

// US shoe sizes 1 through 15 in half-size steps ("1", "1.5", ... "15").
export const SHOE_SIZES = Array.from({ length: 29 }, (_, i) => {
  const size = 1 + i * 0.5;
  return Number.isInteger(size) ? String(size) : size.toFixed(1);
});
